module.exports = __webpack_public_path__ + "static/media/logo.30f8f976.png";